"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Icon = void 0;
const react_1 = __importDefault(require("react"));
const Unchecked_1 = require("./Icons/Unchecked");
const Checked_1 = require("./Icons/Checked");
const Document_1 = require("./Icons/Document");
const Download_1 = require("./Icons/Download");
const Mail_1 = require("./Icons/Mail");
const ChronicPains_1 = require("./Icons/ChronicPains");
const SleepDisorders_1 = require("./Icons/SleepDisorders");
const Migraine_1 = require("./Icons/Migraine");
const Adhs_1 = require("./Icons/Adhs");
const Depression_1 = require("./Icons/Depression");
const Nowomed_1 = require("./Icons/Nowomed");
const User_1 = require("./Icons/User");
const Social_1 = require("./Icons/Social");
const Plus_1 = require("./Icons/Plus");
const Eye_1 = require("./Icons/Eye");
const GarbageCan_1 = require("./Icons/GarbageCan");
const TimelineChecked_1 = require("./Icons/TimelineChecked");
const Chevron_1 = require("./Icons/Chevron");
const Calendar_1 = require("./Icons/Calendar");
const CalendarWithDays_1 = require("./Icons/CalendarWithDays");
const Telemedizin_1 = require("./Icons/Telemedizin");
const MedikalKan_1 = require("./Icons/MedikalKan");
const HealthTracking_1 = require("./Icons/HealthTracking");
const Dashboard_1 = require("./Icons/Dashboard");
const Kontakt_1 = require("./Icons/Kontakt");
const Pharmacy_1 = require("./Icons/Pharmacy");
const Logout_1 = require("./Icons/Logout");
const Menu_1 = require("./Icons/Menu");
const StartTherapie_1 = require("./Icons/StartTherapie");
const Register_1 = require("./Icons/Register");
const AnswerQuestion_1 = require("./Icons/AnswerQuestion");
const DocumentPlus_1 = require("./Icons/DocumentPlus");
const Marker_1 = require("./Icons/Marker");
const Clock_1 = require("./Icons/Clock");
const Media_1 = require("./Icons/Media");
const CheckCircleFilled_1 = require("./Icons/CheckCircleFilled");
const CheckCircle_1 = require("./Icons/CheckCircle");
const Attention_1 = require("./Icons/Attention");
const PharmacySmall_1 = require("./Icons/PharmacySmall");
const PremiumCheck_1 = require("./Icons/PremiumCheck");
const Verified_1 = require("./Icons/Verified");
const react_native_1 = require("react-native");
function Icon({ active = false, icon, size, color, background, }) {
    let iconComp;
    switch (icon) {
        case 'unchecked':
            iconComp = react_1.default.createElement(Unchecked_1.Unchecked, null);
            break;
        case 'checked':
            iconComp = react_1.default.createElement(Checked_1.Checked, { size: size, color: color, background: background });
            break;
        case 'document':
            iconComp = react_1.default.createElement(Document_1.Document, { size: size, color: color });
            break;
        case 'document-plus':
            iconComp = react_1.default.createElement(DocumentPlus_1.DocumentPlus, { size: size, color: color });
            break;
        case 'download':
            iconComp = react_1.default.createElement(Download_1.Download, { size: size });
            break;
        case 'mail':
            iconComp = react_1.default.createElement(Mail_1.Mail, { size: size });
            break;
        case 'chronicPains':
            iconComp = react_1.default.createElement(ChronicPains_1.ChronicPains, { active: active });
            break;
        case 'sleepDisorders':
            iconComp = react_1.default.createElement(SleepDisorders_1.SleepDisorders, { active: active });
            break;
        case 'migraine':
            iconComp = react_1.default.createElement(Migraine_1.Migraine, { active: active });
            break;
        case 'adhs':
            iconComp = react_1.default.createElement(Adhs_1.Adhs, { active: active });
            break;
        case 'depression':
            iconComp = react_1.default.createElement(Depression_1.Depression, { active: active });
            break;
        case 'nowomed':
            iconComp = react_1.default.createElement(Nowomed_1.Nowomed, { size: size });
            break;
        case 'media':
            iconComp = react_1.default.createElement(Media_1.Media, { size: size });
            break;
        case 'user':
            iconComp = react_1.default.createElement(User_1.User, { size: size, color: color });
            break;
        case 'social':
            iconComp = react_1.default.createElement(Social_1.Social, { size: size, color: color });
            break;
        case 'plus':
            iconComp = react_1.default.createElement(Plus_1.Plus, { size: size });
            break;
        case 'premiumCheck':
            iconComp = react_1.default.createElement(PremiumCheck_1.PremiumCheck, { size: size, color: color });
            break;
        case 'eye':
            iconComp = react_1.default.createElement(Eye_1.Eye, { size: size });
            break;
        case 'garbagecan':
            iconComp = react_1.default.createElement(GarbageCan_1.GarbageCan, { size: size, color: color });
            break;
        case 'timelineChecked':
            iconComp = react_1.default.createElement(TimelineChecked_1.TimelineChecked, { size: size });
            break;
        case 'chevron':
            iconComp = react_1.default.createElement(Chevron_1.Chevron, { size: size, color: color });
            break;
        case 'calendar':
            iconComp = react_1.default.createElement(Calendar_1.Calendar, { size: size, color: color });
            break;
        case 'calendarWithDays':
            iconComp = react_1.default.createElement(CalendarWithDays_1.CalendarWithDays, { size: size, color: color });
            break;
        case 'medikalKan':
            iconComp = react_1.default.createElement(MedikalKan_1.MedikalKan, { size: size });
            break;
        case 'telemedizin':
            iconComp = react_1.default.createElement(Telemedizin_1.Telemedizin, { size: size });
            break;
        case 'healthTracking':
            iconComp = react_1.default.createElement(HealthTracking_1.HealthTracking, { size: size, color: color });
            break;
        case 'dashboard':
            iconComp = react_1.default.createElement(Dashboard_1.Dashboard, { color: color });
            break;
        case 'kontakt':
            iconComp = react_1.default.createElement(Kontakt_1.Kontakt, { color: color, size: size });
            break;
        case 'pharmacy':
            iconComp = react_1.default.createElement(Pharmacy_1.Pharmacy, { color: color, size: size });
            break;
        case 'pharmacysmall':
            iconComp = react_1.default.createElement(PharmacySmall_1.PharmacySmall, { color: color, size: size });
            break;
        case 'logout':
            iconComp = react_1.default.createElement(Logout_1.Logout, { color: color });
            break;
        case 'menu':
            iconComp = react_1.default.createElement(Menu_1.Menu, { size: size });
            break;
        case 'startTherapie':
            iconComp = react_1.default.createElement(StartTherapie_1.StartTherapie, { size: size });
            break;
        case 'register':
            iconComp = react_1.default.createElement(Register_1.Register, { size: size });
            break;
        case 'answerQuestion':
            iconComp = react_1.default.createElement(AnswerQuestion_1.AnswerQuestion, { size: size });
            break;
        case 'marker':
            iconComp = react_1.default.createElement(Marker_1.Marker, { color: color, size: size });
            break;
        case 'clock':
            iconComp = react_1.default.createElement(Clock_1.Clock, { color: color, size: size });
            break;
        case 'checkCircleFilled':
            iconComp = react_1.default.createElement(CheckCircleFilled_1.CheckCircleFilled, { color: color, size: size });
            break;
        case 'checkCircle':
            iconComp = react_1.default.createElement(CheckCircle_1.CheckCircle, { color: color, size: size });
            break;
        case 'verified':
            iconComp = react_1.default.createElement(Verified_1.Verified, { color: color, size: size });
            break;
        case 'attention':
            iconComp = react_1.default.createElement(Attention_1.Attention, { color: color, size: size });
            break;
        case 'none':
            iconComp = react_1.default.createElement(react_native_1.View, { style: { width: 50, height: 70 } });
            break;
        default:
            iconComp = react_1.default.createElement(react_1.default.Fragment, null);
    }
    // @ts-ignore
    return iconComp;
}
exports.Icon = Icon;
